<template>
  <div>
    <banner v-for="(banner, index) in banners" :options="banner" :key="banner.id" :position="index" class="banner"> </banner>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Banner from './Banner';

export default {
  name: 'banners',
  components: {
    Banner,
  },
  computed: {
    ...mapGetters(['banners']),
  },
};
</script>

<style scoped>
.banner {
  position: absolute;
  align-self: center;
  right: 35%;
}
</style>
